import { executeNodejsRequest } from './NodejsHttpRequestUtils.js';
/**
 * Adapter for Node Https module to be used as HttpClient
 */
export class BinaryNodejsHttpClient {
    https;
    constructor(https) {
        this.https = https;
    }
    async request(url, requestOptions) {
        return await executeNodejsRequest(this.https, url, requestOptions, (data) => Buffer.from(data));
    }
}
/**
 * Adapter for Node Https module to be used as HttpClient
 */
export class BinaryFetchClient {
    fetch;
    constructor(fetch) {
        this.fetch = fetch;
    }
    async request(url, options) {
        const fetchOptions = {
            method: options.method,
            headers: options.headers,
            body: options.data
        };
        const res = await this.fetch(url, fetchOptions);
        const data = await res.text();
        return {
            ok: res.ok,
            status: res.status,
            statusText: res.statusText,
            data: data
        };
    }
}
export function binaryHttpClient() {
    const noHttpClient = {
        async request(..._) {
            throw new Error('No method available to perform HTTP request');
        }
    };
    if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
        // Use fetch in a browser environment
        return new BinaryFetchClient(window.fetch.bind(window));
    }
    else if (typeof require !== 'undefined') {
        // Use Node https module
        // eslint-disable-next-line
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const https = require('https');
            return new BinaryNodejsHttpClient(https);
        }
        catch (e) {
            return noHttpClient;
        }
    }
    else {
        return noHttpClient;
    }
}
//# sourceMappingURL=BinaryFetchClient.js.map